import { Stack } from "@volca/ui/components/ui/stack";
import type { EnrichedResult } from "@/payroll/editor/types";
import { CheckProblems } from "./check-problems";

export const CalculationResult = ({ result }: { result: EnrichedResult }) => (
  <Stack gap={1} align="stretch">
    <p>{result.checkTitle}</p>
    <CheckProblems result={result} />
    <p className="text-subtle">
      Review the saved proposal on the Pay tab to check employee pay.
    </p>
  </Stack>
);
